import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service';
import {Observable} from 'rxjs';

@Injectable()
export class UserService {
    constructor(private httpService: HttpService) {

    }

    login(username: string, password: string): Observable<boolean> {
        return this.httpService
            .post('/api/user/login', {
                username: username,
                password: password
            });
    }

    logout(): Observable<any> {
        return this.httpService.post('/api/user/logout', {});
    }

    changePassword(oldPassword: string, newPassword: string, code?: string): Observable<boolean> {
        return this.httpService
            .post('/api/user/change-password', {
                oldPassword: oldPassword,
                newPassword: newPassword,
                code: code
            });
    }

    account(): Observable<any> {
        return this.httpService.get('/api/user/account');
    }

    accountInfo(): Observable<any> {
        return this.httpService.get('/api/user/account-info');
    }

    accountEmail(): Observable<string> {
        return this.httpService.get('/api/user/account-email');
    }

    verifyPassword(password: string): Observable<boolean> {
        return this.httpService.post('/api/user/verify-password', password);
    }

    verifyEmail(email: string): Observable<boolean> {
        return this.httpService.post('/api/user/verify-email', email);
    }

    changeActivityType(activityTypeId: string): Observable<boolean> {
        return this.httpService.post('/api/user/change-type', {
            ActivityTypeID: activityTypeId
        });
    }

    changePersonalData(data: any, code?: string): Observable<boolean> {
        let item = {
            Email: data.Email,
            FirstName: data.FirstName,
            LastName: data.LastName,
            CompanyName: data.CompanyName,
            CountryID: data.CountryID,
            NationalityID: data.NationalityID,
            City: data.City,
            ZipCode: data.ZipCode,
            Street: data.Street,
            HouseNumber: data.HouseNumber,
            ApartmentNumber: data.ApartmentNumber,
            TaxID: data.TaxID,
            InformationEmailAccepted: data.InformationEmailAccepted,
            ProcessingDataAccepted: data.ProcessingDataAccepted,
            MarketingContactAccepted: data.MarketingContactAccepted,
            Phone1Prefix: "+" + data.Phone1Prefix,
            Phone1: data.Phone1,
            Phone2: data.Phone2,
            Pesel: data.Pesel,
            DocumentNumber: data.DocumentNumber,
            DocumentExpirationDate: data.DocumentExpirationDate,
            SmsCode: code,
            BirthDate: data.BirthDate
        }
        return this.httpService.post('/api/user/change-personal-data', item);
    }

    changeContactData(data: any): Observable<boolean> {
        return this.httpService.post('/api/user/change-contact-data', data);
    }

    changeLimitData(data: any): Observable<boolean> {
        return this.httpService.post('/api/user/change-limit-data', data);
    }

    changeTransferTitle(data: any, code?: string): Observable<boolean> {
        let item = {
            TransferTitle: data.TransferTitle,
            SmsCode: code
        }
        return this.httpService.post('/api/user/change-transfer-title', item);
    }

    isPep(): Observable<boolean> {
        return this.httpService.get('/api/user/ispep');
    }

    changeIsPep(isPep: boolean, code?: string): Observable<boolean> {
        let item = {
            IsPep: isPep,
            SmsCode: code
        };

        return this.httpService.post('/api/user/change-ispep', item);
    } 

    getRebate(): Observable<any> {
        return this.httpService.get('/api/user/get-rebate');
    }

    docUpload(files: File[]): Observable<boolean> {
        const formData: FormData = new FormData();

        for (let file of files) {
            formData.append('uploadFiles[]', file, file.name);
        }

        return this.httpService.post('/api/user/doc-upload', formData);
    }

    isIdVerified(): Observable<boolean> {
        return this.httpService.get('/api/user/is-doc-verified');
    }

    areIdDocumentsInVerification(): Observable<boolean> {
        return this.httpService.get('/api/user/are-documents-in-verification');
    }

    checkOffer(): Observable<any> {
        return this.httpService.get('/api/user/check-offer');
    }
    
    acceptOffer(offerId: any, accept: boolean): Observable<any> {
        let item = {
            offerId: offerId,
            accept: accept
        }
        return this.httpService.post('/api/user/accept-offer', item);
    }

    getMessages(): Observable<any> {
        return this.httpService.get('/api/user/get-messages');
    }

    readMessage(msgId: any): Observable<any> {
        let item = {
            msgId: msgId
        }
        return this.httpService.get('/api/user/message-read', item);
    }

    isRulesAccepted(type: any): Observable<any> {
        let item = {
            type: type
        }
        return this.httpService.get('/api/user/rules-acceptance', item);
    }
}
